// extracted by mini-css-extract-plugin
export default {"payment-div":"PaymentMethod_payment-div__djXgA","payment-item":"PaymentMethod_payment-item__D4u39"};